var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../utils/sound/utilSound";
import { GridItemContainerDefault } from "../generic/common/GridItemContainerDefault";
import { Recipe } from "../inventory/recipe/Recipe";
export var GridItemNurseryRecipe = function (_a) {
    var item = _a.item, onClick = _a.onClick, className = _a.className;
    var onRecipeClick = function () {
        if (item.isUnlocked) {
            utilSound.event(IdEventSoundCore.ButtonClick);
            if (onClick != undefined) {
                onClick();
            }
        }
        return;
    };
    return (React.createElement(GridItemContainerDefault, { className: "" + className, onClick: onRecipeClick },
        React.createElement("div", { id: "recipe_" + item.recipe, className: "building-item flex flex--guts" },
            React.createElement(Recipe, __assign({}, item, { shouldDisplayInputIcon: false, unlockLevel: item.requiredNurseryLevel, hideTooltip: true, locaId: undefined, isLocked: !item.isUnlocked })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/GridItemNurseryRecipe.tsx
// module id = 2730
// module chunks = 3